import { Button, ChevronDownIcon } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { BottomSheet, FAB, LegacyDropdown } from '@/components'
import { CreateJobForm, PropertyBlockForm } from '@/forms'
import { PropertyQueries } from '@/graphql/queries/property.queries'
import { useToggle } from '@/hooks'
import { useGraphql } from '@/hooks/useGraphql'
import { ReservationProperty } from '@/types/Property'

import { PropertyAccess } from './PropertyAccess/PropertyAccess'
import { PropertyDetail } from './PropertyDetail'

export function Property() {
  const { propertyId } = useParams<{ propertyId: string }>()
  const { isShown, toggle } = useToggle()
  const { isShown: modalShown, toggle: modalToggle } = useToggle()
  const [selectedActionView, setSelectedActionView] = useState<ActionViewType>()
  const [viewValue, setViewValue] = useState<{ name: string; value: string }>(viewOptions[0])
  const [isOpen, setIsOpen] = useState(false)

  function handleViewChange(option) {
    setViewValue(option)
    setIsOpen(false)
  }

  const _propertyId = Number(propertyId)
  const navigate = useNavigate()
  const { data, refetch } = useGraphql<{ property: ReservationProperty }>(
    PropertyQueries.QUERY_KEYS.getReservationProperty,
    PropertyQueries.getReservationProperty(),
    { id: _propertyId },
    {
      enabled: !!_propertyId,
    },
  )

  const showActionModal = (actionView: ActionViewType) => {
    toggle()
    setSelectedActionView(actionView)
    modalToggle()
  }

  const onCreateJobSuccess = () => {
    modalToggle()
  }

  return (
    <div className="flex min-h-140 w-full flex-col p-6">
      <h2 className="text-center text-lg">{data?.property.name || ''}</h2>
      <div className="mb-4 flex items-center justify-between">
        <button className="button-text m-0 p-0 text-sm underline" onClick={() => navigate(-1)}>{`< Back`}</button>
        <LegacyDropdown
          direction="left"
          isOpen={isOpen}
          renderToggle={() => (
            <Button
              className="whitespace-nowrap  bg-action-secondary"
              renderRightIcon={() => <ChevronDownIcon className="w-4" />}
              size="small"
              variant="secondary"
            >
              {viewValue.name}
            </Button>
          )}
          setIsOpen={setIsOpen}
        >
          {viewOptions.map((option, index) => {
            return (
              <button
                className={clsx(
                  'px-6 py-2 first-of-type:pt-4 last-of-type:pb-4 hover:text-link-deemphasized focus-visible:text-link-deemphasized',
                  option.value === viewValue.value ? 'text-text-link' : 'text-icon-secondary',
                )}
                key={index}
                onClick={() => handleViewChange(option)}
              >
                {option.name}
              </button>
            )
          })}
        </LegacyDropdown>
      </div>

      {viewValue.value === viewOptionValues.DETAILS && <PropertyDetail propertyId={_propertyId} />}
      {viewValue.value === viewOptionValues.ACCESS && <PropertyAccess propertyId={_propertyId} />}
      <FAB isShown={isShown} toggle={toggle}>
        {actionViews.map((actionView) => {
          return (
            <button
              className="w-full whitespace-nowrap py-3 font-medium"
              key={actionView?.name}
              onClick={() => showActionModal(actionView)}
            >
              {actionView.name}
            </button>
          )
        })}
      </FAB>
      <BottomSheet header={selectedActionView?.modalHeader || ''} isVisible={modalShown} onClose={modalToggle}>
        <div className="px-6">
          {selectedActionView?.value === 'property_block' && (
            <PropertyBlockForm propertyId={_propertyId} refetchOnSuccess={refetch} toggle={modalToggle} />
          )}
          {selectedActionView?.value === 'create_job' && (
            <CreateJobForm onSuccess={onCreateJobSuccess} propertyId={_propertyId} />
          )}
        </div>
      </BottomSheet>
    </div>
  )
}

enum viewOptionValues {
  ACCESS = 'access',
  DETAILS = 'details',
}

export const viewOptions = [
  {
    name: 'Details',
    value: viewOptionValues.DETAILS,
  },

  {
    name: 'Access',
    value: viewOptionValues.ACCESS,
  },
]

export type ActionViewType = (typeof actionViews)[0]

const actionViews = [
  { name: 'Add Block Reason', value: 'property_block', modalHeader: 'Property Block Reason' },
  { name: 'Create Host Job', value: 'create_job', modalHeader: 'Create Host Job' },
]
